import React from "react";
import { useSelector } from "react-redux";
import ConditionTable from "./ConditionTable";
import Loader from "../Loader";

function CurrentConditions() {
    const currentConditions = useSelector(state => state.buoys.currentConditions)
    const loading = useSelector(state => state.buoys.loading)

    return(
        <div className="">
            <h2>Current Conditions</h2>
            <p className='description m-1'>
                Here are the current conditions (over last 2 hours) for all buoys associated with this break. 
                Hope you score, brah!
            </p>

            {!loading ? <div>
                {currentConditions.map(condition => {
                    return(
                        <ConditionTable
                            key={condition.buoyID}
                            buoyID={condition.buoyID}
                            buoyName={condition.buoyName}
                            meteorological={condition.meteorological}
                            spectral={condition.spectral}
                        />
                    )
                })}
            </div> : <Loader />}
        </div>
    )
}

export default CurrentConditions;